import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import { saveAs } from 'file-saver';

interface WarehouseClientsReportState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;


    filter: {
        dZoneGroups: any;
        targetDates: Date[];
    };

    items: any[];
}

const state: WarehouseClientsReportState = {
    loading: false,
    loaded: false,
    fatalError: false,

    filter: {
        dZoneGroups: null,
        targetDates: [new Date(), new Date()],
    },

    items: [],
};

function buildFilter(params: any) {
    const queryParams: any = {}

    if (params.targetDates) {
        queryParams.date_from = moment(params.targetDates[0]).format('YYYY-MM-DD');
        queryParams.date_to = moment(params.targetDates[1]).format('YYYY-MM-DD')
    }
  
    if (params.dZoneGroups) {
        queryParams.delivery_zone_id = params.dZoneGroups;
    }

    if (params.sortField !== null) {
        queryParams.order_by = params.sortField;
        queryParams.order_type = params.sortDirection;
    }

    return queryParams;
}

export const REPORT_DATA = 'REPORT_DATA';

export const actions: ActionTree<WarehouseClientsReportState, RootState> = {

    loadData({ commit, state, dispatch }, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {

            if (Object.values(params).length > 0) {
                commit('START_LOADING');

                vm.$db([
                    vm.$q(REPORT_DATA)
                        .raw('reports.warehouses_clients')
                        .action(buildFilter(params)),
                ]).then(((result: ServerResult) => {
                    commit('SET_REPORT_DATA', result.getOperation(REPORT_DATA).getContent());
                    commit('LOADED_SUCCESS');
    
                    resolve();
                }));
            } else {
                resolve();
            }
        })
    },

    exportDataAsXLSX({rootState}, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('EXPORT')
                .raw('reports.warehouses_clients.export')
                .action({ ...buildFilter(params), format: 'xlsx'})
            ]).then(((result: ServerResult) => {
                const exportOpContent = result.getOperation('EXPORT').getContent();
                const fToken = exportOpContent.token;
                const aToken = (rootState as any).ubic.token
                const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
                saveAs(fileUrl, 'export.xlsx')

                resolve();
            }));
        })
    },


};

export const mutations: MutationTree<WarehouseClientsReportState> = {
    START_LOADING: (state) => {
        // state.loaded = false;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.fatalError = true;
    },

    SET_REPORT_DATA(state, data) {
        state.items = data.documents[0].clients;
    },
};

const getters = {

};

export const STORE_KEY = '$_warehouse_clients_report';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
